export default {
  mediaUploadImage: "Please select an image file",
  mediaUploadVideo: "Please select a video file",
  mediaUploadEither: "Please select an image or video file",
  mediaUploadMax: "File must be less than {{max}}",
  mediaUploadSuccess: "{{type}} uploaded",
  storageUploadProcessing: "Saving on server...",
  storageUploadPercent: "{{percent}}%",
  storageUploadTooLarge: "File is too large. Maximum size is {{max}}.",
  storageUploadFailed: "Failed to upload file",
  storageUploadFailedNamed: "Failed to upload {{name}}",
  storageUploadFileProgress: "Uploading {{name}} ({{current}} of {{total}})",
  mediaUploadButton: "Upload",
  imageCrop: {
    title: "Crop photo",
    confirm: "Use photo",
    cancel: "Skip",
    zoom: "Zoom",
    failed: "Could not crop this photo. Try another image.",
  },
  receiptUploadAnalyzing: "Analyzing...",
  receiptUploadLabel: "Upload receipt",
  receiptUploadBeforeVisit:
    "This action is only available after the booking start time",
  receiptUploadTooLarge: "File is too large. Maximum size is {{max}}.",
  receiptUploadUnsupported: "Please upload an image or PDF receipt.",
  receiptModalTitle: "Receipt uploaded",
  receiptModalSubtitle: "Verify the extracted total",
  receiptModalExtracted: "Total extracted from receipt:",
  receiptModalConfirmHint: "Please confirm this amount is correct",
  receiptModalMismatch:
    'Is this amount correct? If the total doesn\'t match the receipt, select "Retake photo".',
  receiptModalConfirming: "Confirming...",
  receiptModalYes: "Yes, it's correct",
  receiptModalRetake: "No, retake photo",
  receiptOcrFailureTitle: "Could not read receipt",
  receiptOcrFailureAttemptsRemaining:
    "{{remaining}} of {{max}} validation attempts remaining",
  receiptOcrFailureManualHint:
    "Automatic reading did not succeed. You can upload another photo or enter the total manually.",
  receiptOcrFailureRetry: "Upload another photo",
  receiptOcrFailureManualAmount: "Enter amount manually",
  receiptPreviewAlt: "Receipt photo",
  receiptViewFull: "View receipt photo",
  receiptDownload: "Download receipt",
  receiptDownloadFailed: "Could not download the receipt. Try again.",
  attachmentViewFull: "View image",
  attachmentDownload: "Download",
  attachmentDownloadFailed: "Could not download the file. Try again.",
  countrySelectSearchPlaceholder: "Search country...",
  countrySelectNoResults: "No country found",
  multiSelectPlaceholder: "Select options...",
  multiSelectRemoveChip: "Remove {{label}}",
  receiptManualAmountTitle: "Enter receipt total manually",
  receiptManualAmountSubtitle:
    "Automatic receipt reading did not succeed. Enter the total amount shown on the receipt.",
  receiptManualAmountLabel: "Receipt total (EUR)",
  receiptManualAmountPlaceholder: "e.g. 42.50",
  receiptManualAmountInvalid: "Enter a valid amount greater than zero",
  receiptManualAmountSubmit: "Save total",
  transactionCustomer: "Customer:",
  transactionOpenBooking: "Open booking",
  walletMovements: {
    badges: {
      income: "Income",
      expense: "Expense",
      settlement: "Settlement",
      refund: "Refund",
    },
    checkout_payment: {
      title: "Customer payment",
    },
    restaurant_fee: {
      title: "Restaurant commission credit",
    },
    refund: {
      title: "Refund adjustment",
    },
    settlement_sent: {
      title: "Settlement transferred to your bank account",
      titleWithReference:
        "Settlement transferred to your bank account (ref: {{reference}})",
    },
    settlement_received: {
      title: "Settlement received in wallet",
      titleWithReference: "Settlement received in wallet (ref: {{reference}})",
    },
    host_payout: {
      title: "Host payout",
    },
    host_commission: {
      title: "Commission",
    },
    sales_agent_commission: {
      title: "Sales agent commission",
    },
    internal_fee: {
      title: "Platform fee adjustment",
    },
    unknown: {
      title: "Wallet movement",
    },
  },
  translationAllRequired: "All languages required",
  translationCharCount: "{{current}}/{{max}}",
  translationOverLimit:
    "One or more languages exceed the {{max}} character limit. Shorten the text in the red languages.",
  mediaTypeImage: "Image",
  mediaTypeVideo: "Video",
  itemThumbnailAlt: "Item image",
  productItem: {
    imageTooLarge: "Image too large. Maximum size is 10MB.",
    menuItemCreated: "Menu item created",
    serviceCreated: "Service created",
    menuItemUpdated: "Menu item updated",
    serviceUpdated: "Service updated",
    noCategory: "No category",
    titleEditMenu: "Edit Menu Item",
    titleEditService: "Edit Service",
    titleAddMenu: "Add Menu Item",
    titleAddService: "Add Service",
    allTranslationsRequired: "Name is required in every language",
    descriptionPartial:
      "Description must be empty or translated in every language",
    autoTranslateHint:
      "Name is required in every language; description must be empty or complete in every language. Fill at least one language, then generate translations. After a rename, generate again to update the other languages.",
    autoTranslateGenerate: "Generate translations",
    autoTranslateConfirmTitle: "Fill missing translations?",
    autoTranslateConfirm:
      "This will generate translations only for empty languages. Existing text will not be changed.",
    autoTranslateRefreshTitle: "Update other languages?",
    autoTranslateRefreshConfirm:
      "All languages already have text. Other languages will be replaced with translations from the source language.",
    autoTranslateApplied: "Translations applied",
    validPriceRequired: "Please enter a valid price",
    showKioskDiscountLabel: "Show as discounted on devices",
    showKioskDiscountHint:
      "The discounted price will be shown on devices and is what customers will pay.",
    undiscountedPriceEuro: "Undiscounted price (€)",
    discountedPriceEuro: "Discounted price (€)",
    validUndiscountedPriceRequired: "Please enter a valid undiscounted price",
    validDiscountedPriceRequired: "Please enter a valid discounted price",
    discountedMustBeLower:
      "Discounted price must be lower than the undiscounted price",
    photo: "Photo",
    photoHint: "Max 10MB",
    addPhoto: "Add photo",
    category: "Category",
    priceEuro: "Price (€)",
    name: "Name",
    description: "Description",
    placeholderPriceMenu: "12.50",
    placeholderPriceService: "25.00",
    placeholderNameMenu: "Dish name",
    placeholderNameService: "Service name",
    placeholderDescMenu: "Dish description",
    placeholderDescService: "Service description",
    hintDescMenu: "Optional — describe ingredients, preparation, etc.",
    hintDescService: "Optional — describe what the service includes",
    previewAlt: "Preview",
    saveChanges: "Save Changes",
    addItem: "Add Item",
    addService: "Add Service",
  },
  productItems: {
    menu: {
      title: "Menu",
      emptyTitle: "No menu items yet",
      emptySubtitle: "Add your first dish to the menu",
      addButton: "Add Item",
      deleteSuccess: "Menu item deleted",
    },
    service: {
      title: "Services Offered",
      emptyTitle: "No services yet",
      emptySubtitle: "Add the services you offer to customers",
      addButton: "Add Service",
      deleteSuccess: "Service deleted",
    },
    toastDeleteErrorMenu: "Error deleting menu item",
    toastDeleteErrorService: "Error deleting service",
    toastUpdateErrorMenu: "Error updating menu item",
    toastUpdateErrorService: "Error updating service",
    toastReorderError: "Error reordering items",
    confirmDelete: 'Delete "{{name}}"?',
    thisItem: "this item",
    filterAll: "All ({{count}})",
    uncategorized: "Uncategorized ({{count}})",
  },
  transactionsSection: {
    titleDefault: "Transactions",
    filters: "Filters",
    dateRange: "Date Range",
    activity: "Activity",
    allActivities: "All Activities",
    searchInDescription: "Search in description",
    searchPlaceholder: "Search...",
    minAmountEuro: "Min Amount (€)",
    minAmountPlaceholder: "0.00",
    maxAmountEuro: "Max Amount (€)",
    noLimit: "No limit",
    reset: "Reset",
    applyFilters: "Apply Filters",
    credits: "Credits",
    debits: "Debits",
    transactionsCountLabel: "Transactions",
    loadingTransactions: "Loading transactions...",
    emptyTitle: "No transactions",
    emptyDescription: "No transactions found",
  },
  sortableItem: {
    itemAltFallback: "Item",
    hidden: "Hidden",
    hide: "Hide",
    show: "Show",
    discounted: "Discounted",
  },
} as const;
